import { Component,ViewEncapsulation} from '@angular/core'; 
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';  
import { AuthService } from '../../_services';
import { LoaderService } from '../../_services/loader.service'; 

import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 

import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
const moment = _rollupMoment || _moment;   

declare var $: any; 
const distinctStatus = data => data.filter((x, idx, xs) => xs.findIndex(y => y.Status === x.Status) === idx); 
  
@Component({ 
  selector: 'Attendance',
  templateUrl: './attendanceDetail.component.html', 
  encapsulation: ViewEncapsulation.None,
  styles: ['.green .codeColumn {color: green; font-weight:bold} .red .codeColumn {color: red; font-weight: bold}'],
})
export class AttendanceDeatilComponent { 
    prjId:any;  
    showLoader:boolean;  
    startDate:any;
    endDate:any;
    defStartDt:any;
    defEndDt:any;
    dateRange:any; 
    attendanceReportList:any
    serialNo:any;
    currentDateModal:any;
    defaultStartDate:any
    defaultEndDate:any
    search:any
  
    public dataRangeModal: any
  public checkboxOnly = false;
  public mode = 'multiple';
  public attendanceDetail:any;

  

 
  constructor(private http : HttpClient ,private auth : AuthService,public routes: ActivatedRoute, public router: Router,private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) =>{
        this.showLoader = val; 
      });
    var date = new Date();   
    this.currentDateModal=date;
    this.defaultStartDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dataRangeModal = { beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
  }  
  

    /*
    * GET ATTENDANCE REPORT
    */ 
   getAttendanceList(startDate, endDate){   
         this.loaderService.display(true);  
                this.http.get(environment.apiUrl + 'attendance/getAttendanceDetailAll?prjid=' + this.prjId + "&startDate=" + startDate + "&endDate=" + endDate).subscribe(data =>{ 
                this.attendanceReportList=data;
                console.log(data);
                 
                if(this.attendanceReportList.length>0){ 
                  
                  
                    this.loaderService.display(false); 
                }else{
                    this.loaderService.display(false); 
                   
                } 
            });  
   } 

 



onDateRangeChanged(dataRange) {
  if (dataRange.beginDate.day > 0) {
  this.startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
  this.endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
  this.getAttendanceList(this.startDate,this.endDate);
  }
  else if (dataRange.beginDate.day == 0) {
  this.startDate = this.defaultStartDate
  this.endDate = this.defaultEndDate
  this.getAttendanceList(this.startDate,this.endDate);
  }
}


importReport(vehVtsDailyList){
  const ws_name = 'VtsReport';
  const wb: WorkBook = { SheetNames: [], Sheets: {} };
  const ws: any = utils.json_to_sheet(vehVtsDailyList);
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;
  const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 
  'binary' });
  saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'Attendance.xlsx');
  }s2ab(s){
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
  } 


 
 
    ngOnInit() {  
        this.startDate = moment(new Date()).format('YYYY-MM-DD');
        this.endDate= moment(new Date()).format('YYYY-MM-DD');
        this.prjId = this.auth.getAuthentication().projectId  
        this.getAttendanceList(this.startDate,this.endDate);
    } 
}
  
  
  


   


 
 

 



 


// WEBPACK FOOTER //
// ./src/app/reports/attendance/attendanceDetail.component.ts